import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import { getViewDefintionFromObject } from '../../factories/AttributeDefinitions';
import { ReadOnlyList } from '../../factories/ReadOnlyList';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const ReadOnlyListWidget = (props) => {
    const component = useMemo(() => (_jsx(_Fragment, { children: props.contextCustomer && (_jsx(ReadOnlyList, { matchedPrimary: props.contextCustomer, objects: [props.contextCustomer], viewDefinition: getViewDefintionFromObject(props.contextCustomer) })) })), [props.contextCustomer]);
    return {
        name: 'ReadOnlyList',
        category: 'composite',
        component,
    };
};
